/**
 * index.ts - List Manager Plugin Entry Point
 * 
 * Multi-package plugin that orchestrates:
 * - Organizr (static list management)
 * - Outlinr (hierarchical editing)
 * - Listr (dynamic list queries)
 * 
 * SELF-REGISTRATION:
 * This plugin registers itself with PluginRegistry on import
 */

import { registerPlugin } from '../../PluginRegistry';
import ListManagerPlugin from './ListManagerPlugin';

// Self-register with PluginRegistry
registerPlugin({
  id: 'list-manager',
  name: 'List Manager',
  description: 'Manage OpCentral list library with Outlinr and Organizr',
  category: 'data',
  version: '2.0.0',
  author: 'OpCentral',
  tags: ['lists', 'organizr', 'outlinr', 'listr', 'data-management', 'json'],
  
  // Component information
  hasComponent: true,
  componentPackage: '@opcentral/organizr',
  componentExport: 'ListManagerView',
  
  // Plugin loader
  loader: async () => ListManagerPlugin
});

// Standard exports
export { default as ListManagerPlugin } from './ListManagerPlugin';
export { default } from './ListManagerPlugin';
